import { createContext, useContext } from 'react';

export type ToastMessage = {
    id?: number | undefined ;
    message: string;
    type: 'success' | 'error' | 'warning' | 'info';
    duration?: number;
};

type ToastContextType = {
    /** Adds a toast and returns its assigned numeric id. */
    addToast: (message: ToastMessage) => number;
    /** Immediately dismisses the toast with the given id. */
    removeToast: (id: number) => void;
};

export const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};
